import { styled } from "styled-components";

export const ContainerBox = styled.div`
  border: 1px solid #383838;
  border-radius: 12px;
  padding: 24px;
  margin-top: 24px;
`;
